// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-virtual-table{position:relative}.v-virtual-table__wrapper{display:-webkit-box;display:-ms-flexbox;display:flex}.v-virtual-table__table{width:100%;height:100%;overflow-x:auto}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
